var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14558_14483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8748 24H14.6248C14.0044 24 13.4998 23.4953 13.4998 22.875V15.125C13.4998 14.5047 14.0044 14 14.6248 14H15.8748C16.4951 14 16.9998 14.5047 16.9998 15.125V22.875C16.9998 23.4953 16.4951 24 15.8748 24Z",
    fill: "#3167F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1248 24H9.87476C9.25441 24 8.74976 23.4953 8.74976 22.875V17.625C8.74976 17.0047 9.25441 16.5 9.87476 16.5H11.1248C11.7451 16.5 12.2498 17.0047 12.2498 17.625V22.875C12.2498 23.4953 11.7451 24 11.1248 24Z",
    fill: "#3167F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.625 24H19.375C18.7547 24 18.25 23.4953 18.25 22.875V12.5H17.5632C17.242 12.5 16.9592 12.3187 16.825 12.027C16.6908 11.7352 16.7373 11.4026 16.9463 11.1587C16.9486 11.1559 16.9511 11.1532 16.9535 11.1504L19.6277 8.16631C19.7225 8.06047 19.8579 8 20 8C20.1422 8 20.2775 8.06047 20.3724 8.16631L23.0466 11.1504C23.049 11.1532 23.0515 11.1559 23.0538 11.1587C23.2628 11.4025 23.3093 11.7352 23.1751 12.027C23.0409 12.3187 22.758 12.5 22.4369 12.5H21.75V22.875C21.75 23.4953 21.2454 24 20.625 24Z",
    fill: "#3167F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14558_14483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChart);
export default __webpack_public_path__ + "static/media/ic_chart.627d954b846ea25d98ef8955832e4122.svg";
export { ForwardRef as ReactComponent };